import * as React from 'react';
import * as ReactDOM from 'react-dom';
import './index.scss'

interface IProps {
	open?(): void,
	close?(): void,
}

class DialogBox extends React.Component <IProps , any>{
    constructor(props: any){
        super(props);
        this.state = {
            show: false, //是否显示提示框
            titleText:'提示', //标题
            promptText:'网络错误', //提示
            cancelText:'取消',
            confirmText:'确认',
            isShortTip:true, //是否为短提示，短提示的情况下不显示'取消''确认'（且2s后消失），且优先级最高，其他配置无效
            isShowCancel: false, //是否显示确认按钮
            isShowConfirm: false, //是否显示确认按钮
            cancelCallbackFn: function(){}, //取消 回调函数
            confirmCallbackFn: function (){},//确认 回调函数
            callback: '', //消失后的回调
            style: '',  // 弹框风格
        }
    }
 
    //打开提示框
    public open = (options: any) => {
        options = options || {};
        
        //如果是短提示
        if(!options.isShortTip){
            options.isShowCancel = false;
            options.isShowConfirm = false;
            setTimeout(()=>{
                this.close();
                options.callback ? options.callback() : '';
            }, 1500)
        }
 
        options.show = true;
        this.setState({
            ...options
        })
    }
    //取消
    public cancel = () => {
        this.state.cancelCallbackFn();
        this.close()
    }
    //确认
    public confirm = () => {
        this.state.confirmCallbackFn();
        this.close()
    }
    public  close() {
        this.setState({
            show:false
        })
    }
 
    public  render(){
        let opts = this.state;
        return (
            <div className={`dialog-box ${opts.style ? opts.style : ''}`} style={opts.show? {display:'flex'}:{display:'none'}}>
                <div className="dialog-content">
                    <h6 className="title">{opts.titleText}</h6>
                    <p className="prompt" dangerouslySetInnerHTML={{__html:opts.promptText}}></p>
                    {!opts.isShowCancel && !opts.isShowConfirm ? null : (
                        <div className="btn-box">
                            {opts.isShowCancel ? (<span className="btn" onClick={ () => this.cancel() }>{opts.cancelText}</span>) : null}
                            {opts.isShowConfirm ? (<span className="btn confirm" onClick={ () => this.confirm() }>{opts.confirmText}</span>) : null}
                        </div>
                        )}
                </div>
            </div>
        )
    }
}
 
let div = document.createElement('div');
document.body.appendChild(div);
let DialogAlert = ReactDOM.render(<DialogBox /> ,div); //返回实例
 
export default (DialogAlert as any);